import MainContext from "context/MainContext"
import moment, { utc } from "moment-timezone"
import { useState, useEffect, useContext, useRef } from "react"
import "./DateTime.scss"
import { consoleLog } from "utils/functions"
import { Reset16 } from '@carbon/icons-react';

const { TimePicker, DatePicker, DatePickerInput, TimePickerSelect, SelectItem, FormGroup } = require("carbon-components-react")

const Datetime = (props) => {

    const [init, setInit] = useState(false)
    const [initValue, setInitValue] = useState()
    const [timezone, setTimezone] = useState()
    const [formattedDateValue, setFormattedDateValue] = useState()
    const [datePickerValue, setDatePickerValue] = useState() // moment().format('DD-MM-YYYY')
    const [timePickerValue, setTimePickerValue] = useState() // "00:00"

    const [timePickerInvalid, setTimePickerInvalid] = useState(false)
    const [timePickerInvalidText, setTimePickerInvalidText] = useState("")

    // const pattern = "(1[012]|[1-9]):[0-5][0-9](\\s)?"
    const pattern = "^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$"
    const context = useContext(MainContext)

    const containerElement = useRef(null);

    useEffect(() => {
        setInitValue(props.defaultValue)
    }, [props.defaultValue])

    useEffect(() => {
        if (!initValue) {
            return false
        }
        let value = parseDatetime(initValue)
        if (!value || init) {
            return false
        }

        // value = value.tz(context.evt.timezone)
        const date = value.format('DD-MM-YYYY')
        const formattedDate = value.format('YYYY-MM-DD')
        const time = value.format('HH:mm')
        if (date) {
            setDatePickerValue(date)
            setFormattedDateValue(formattedDate)
            // setDateValue(date)
        }
        if (time) {
            setTimePickerValue(time)
            // setTimeValue(time)
        }
        if (timezone) {
            setInit(true)
        }
    }, [initValue, timezone])

    useEffect(() => {
        setTimezone(props.timezone)
    }, [props.timezone])

    useEffect(() => {
        setTimePickerInvalid(props.invalid)
        setTimePickerInvalidText(props.invalidText)
    }, [props.invalid, props.invalidText])

    useEffect(() => {
        if (!formattedDateValue && !timePickerValue) {
            return
        }
        onChange()
    }, [formattedDateValue, timePickerValue])

    const parseDatetime = (dateTime, noTimezone) => {
        consoleLog("onchange timezone", context.evt.timezone)
        if (!dateTime) {
            return null
        }
        let value = null;
        if (noTimezone) {
            value = moment(dateTime)
        }
        else {
            value = utc(dateTime)
            if (context.evt.timezone) {
                value = value.tz(context.evt.timezone)
            }
        }

        return value
    }

    const onChange = () => {
        const time = timePickerValue || "00:00"
        const timeRadix = moment.tz(formattedDateValue + " " + time, context.evt.timezone)
        let a = timeRadix.format();
        const regex2 = /Z$/;
        a = a.replace(regex2, timeRadix.format("Z"))
        consoleLog("onchhange", a)
        props.onChange(a)
    }

    const changeDate = (e) => {
        if (e) {
            const value = parseDatetime(e[0], true)
            const date = value.format('DD-MM-YYYY')
            consoleLog("onchange date", value)
            if (date) {
                setFormattedDateValue(value.format('YYYY-MM-DD'))
                setDatePickerValue(date)
            }
        }
        else {
            setFormattedDateValue()
            setDatePickerValue(null)
        }
    }

    const changeTime = (e) => {
        consoleLog("changeTime", e)
        if (e) {
            const time = e.target.value
            const re = new RegExp(pattern);
            if (!re.test(time)) {
                setTimePickerInvalid(true)
                setTimePickerInvalidText("Invalid time")
            }
            else {
                setTimePickerInvalid(false)
                setTimePickerInvalidText("")
            }
            consoleLog("onchange changeTime", e.target.value)
            setTimePickerValue(e.target.value)
        }
        else {
            setTimePickerInvalid(false)
            setTimePickerInvalidText("")
            setTimePickerValue("")
        }
    }

    const reset = () => {
        // consoleLog("reset")
        // setTimePickerValue(null)
        // setDatePickerValue(null)
        // setDatePickerValue(null)
        // setFormattedDateValue("")
        changeDate()
        changeTime()
        props.onChange({
            target: {
                value: null
            }
        })
    }

    const timepickerAmPm = (props.timepickerAmPm) ? (
        <TimePickerSelect id={`${props.id}-time-picker-lselect-ampm`}>
            <SelectItem value="AM" text="AM" />
            <SelectItem value="PM" text="PM" />
        </TimePickerSelect>
    ) : null

    const timepickerTimezone = (props.timepickerTimezone) ? (
        <TimePickerSelect id={`${props.id}-time-picker-lselect-timezone`} >
            <SelectItem value="Time zone 1" text="Time zone 1" />
            <SelectItem value="Time zone 2" text="Time zone 2" />
        </TimePickerSelect>
    ) : null

    const timePicker = (props.timepicker) ? (
        <TimePicker
            id={`${props.id}-time-picker`}
            onChange={(e) => changeTime(e)}
            value={timePickerValue}
            invalid={timePickerInvalid}
            invalidText={timePickerInvalidText}
        >
            {timepickerAmPm}
            {timepickerTimezone}
        </TimePicker>
    ) : null


    const datePicker = (
        <DatePicker
            dateFormat={props.dateFormat || "d/m/Y"}
            datePickerType="single"
            onChange={(e) => changeDate(e)}
            allowInput={true}
            maxDate={props.maxDate}
            minDate={props.minDate}
            appendTo={containerElement.current}
            value={datePickerValue}
        >
            <DatePickerInput
                id={`${props.id}-date-picker-calendar`}
                labelText={""}
                placeholder={props.placeholder}
                pattern={pattern}
                type="text"

            // key={`datepickerinput-${props.id}-${datePickerValue}`}
            // onChange={(e) => changeDate(e)}
            />
        </DatePicker>
    )

    return (
        <>
            <FormGroup legendText={props.labelText} ref={containerElement}>
                <div style={{ position: "relative", display: "inline-block", verticalAlign: "middle" }}>
                    {datePicker}
                </div>
                <div style={{ position: "relative", display: "inline-block", verticalAlign: "middle" }}>
                    {timePicker}
                </div>
                {
                    datePickerValue || timePickerValue ? (
                        <div
                            style={{
                                position: "relative",
                                display: "inline-block",
                                verticalAlign: "middle",
                                marginLeft: "1rem",
                                cursor: "pointer"
                            }}
                            onClick={reset}
                        >
                            <Reset16 />
                        </div>
                    ) : null
                }


                {/* <div style={{ position: "relative", display: "inline-block", verticalAlign: "bottom" }}>
                    <Button
                        kind="ghost"
                        renderIcon={Add16}
                        tooltipAlignment="center"
                        tooltipPosition="bottom"
                        iconDescription="Reset"
                        size='field'
                        onClick={reset}
                        hasIconOnly
                    />
                </div> */}
            </FormGroup>
        </>
    )
}

export default Datetime